var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCroatia = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 11H31V21H1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z",
    fill: "#ea3323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z",
    transform: "rotate(180 16 24)",
    fill: "#100e91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z",
    opacity: 0.15
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.001,22h0c2.524,0,4.59-2.065,4.59-4.59v-5.454H11.412v5.454c0,2.524,2.065,4.59,4.59,4.59h0Z",
    fill: "#ea3323"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.001,21.926h0c2.476,0,4.502-2.026,4.502-4.502v-5.38H11.499v5.38c0,2.476,2.026,4.502,4.502,4.502Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.399,12.214h-1.733v1.904h1.733v-1.904Z",
    fill: "#ea3323"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.399,16.021h1.733v-1.904h-1.733v1.904Z",
    fill: "#ea3323"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667,17.414c0,.173,.011,.343,.031,.511h1.702v-1.904h-1.733v1.393Z",
    fill: "#ea3323"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.865,16.021h-1.733v1.904h1.733v-1.904Z",
    fill: "#ea3323"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.865,19.828h1.733v-1.904h-1.733v1.904Z",
    fill: "red"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.598,20.87c.384-.29,.719-.642,.989-1.041h-.989v1.041Z",
    fill: "#ea3323"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4,19.828h1.733v-1.904h-1.733v1.904Z",
    fill: "#ea3323"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.409,19.828c.271,.4,.606,.752,.991,1.043v-1.043h-.991Z",
    fill: "#ea3323"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3,21.732c.192-.013,.38-.039,.565-.077v-1.827h-1.733v1.827c.184,.038,.372,.063,.563,.077,.202,.012,.404,.012,.605,0h0Z",
    fill: "#ea3323"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.298,17.925c.02-.168,.031-.339,.031-.513v-1.391h-1.731v1.904h1.7Z",
    fill: "#ea3323"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.865,16.021h1.733v-1.904h-1.733v1.904Z",
    fill: "#ea3323"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.865,12.214h-1.733v1.904h1.733v-1.904Z",
    fill: "#ea3323"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.329,14.117v-1.904h-1.731v1.904h1.731Z",
    fill: "#ea3323"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.426,11.9l1.074-2.435-.818-1.322-1.356,.502-.952-1.088-1.255,.719-1.119-.916-1.119,.916-1.255-.719-.952,1.088-1.356-.502-.819,1.322,1.073,2.436c1.352-.612,2.851-.953,4.427-.953s3.074,.341,4.426,.952h0Z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.705,8.753l-.002,.002-1.345-.498-.753,1.215,.288,.655,.73,1.658c.545-.241,1.114-.439,1.701-.588l-.62-2.444h0Z",
    fill: "#0093dd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.893,8.387l-.002,.002-1.244-.713-.942,1.077,.62,2.444c.576-.147,1.169-.247,1.777-.297l-.208-2.513h0Z",
    fill: "#100e91"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.112,8.388l-.003,.002-1.109-.908-1.107,.907,.208,2.513c.296-.024,.596-.038,.899-.038s.605,.013,.903,.038l.209-2.513h0Z",
    fill: "#0093dd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3,8.754h-.003s-.944-1.078-.944-1.078l-1.241,.711-.209,2.513c.608,.05,1.201,.151,1.777,.297l.621-2.444h0Z",
    fill: "#100e91"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.375,11.785l1.02-2.312-.753-1.215-1.342,.497-.621,2.444c.585,.149,1.152,.347,1.695,.587h0Z",
    fill: "#0093dd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z",
    fill: "#fff",
    opacity: 0.2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCroatia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Croatia.3c976a763ff553d72d622103bae07610.svg";